declare global {
    interface Array<T> {
        any(): boolean;
        distinct(): Array<T>;
    }
}

Array.prototype.any = function (): boolean {
    return this != undefined && this.length > 0;
}

Array.prototype.distinct = function <T>(): Array<T> {
    const onlyUnique = (value: any, index: number, self: any) => {
        return self.indexOf(value) === index;
    }
    return this.filter(onlyUnique);
}


export { }; 